import { z } from 'zod';

export const TransitMarkCustomsNotificationAsReadSchema = z.object({
  transitId: z.string().min(1, { message: 'Required' }),
  notificationId: z.string().min(1, { message: 'Required' }),
});
export type TransitMarkCustomsNotificationAsReadData = z.infer<typeof TransitMarkCustomsNotificationAsReadSchema>;
